export default "__VITE_ASSET__Cfq1L7et__"